/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Fade,
  IconButton,
  InputLabel,
  Modal,
  Link,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { UserService } from 'services/User/UserService';
import { Toast } from 'components/Toast';
import { getFriendlyErrorMessage } from 'utils/errorHelper';

import {
  GET_TITLES_AS_CONTENTMANAGER,
  REPLICATE_CONTENT_BY_TITLE,
} from 'queries/titleContent';
import { ApolloError, useMutation, useQuery } from '@apollo/client';

import useStyles from './styles';

interface ICreateContentTranslationProps {
  selectedItems: Map<string, ITitle>;
}

const CreateContentTranslation: React.FC<ICreateContentTranslationProps> = ({
  selectedItems,
}) => {
  const classes = useStyles();
  const sites = UserService.useSitesFromAccess();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [titles, setTitles] = useState([]);
  const [originalTitleId, setOriginalTitleId] = useState<string | null>(null);
  const [filterSearchText, setFilterSearchText] = useState('');

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleChange = (
    // eslint-disable-next-line @typescript-eslint/ban-types
    event: React.ChangeEvent<{}>,
    newValue: ITitle | null,
  ) => {
    setOriginalTitleId(newValue?.id || null);
  };

  const [mutation] = useMutation(REPLICATE_CONTENT_BY_TITLE, {
    onCompleted: () => {
      Toast('Action executed with success!');
    },
    onError: (error: ApolloError) => {
      Toast(getFriendlyErrorMessage(error), 'error');
    },
  });

  const queryTitles = useQuery(GET_TITLES_AS_CONTENTMANAGER, {
    variables: {
      accountManagerEmail: null,
      byPublishPost: false,
      dateEnd: '2025-05-24T02:59:59.999Z',
      dateStart: '2018-01-01T02:00:00.000Z',
      language: null,
      limit: 10,
      offset: 0,
      searchText: filterSearchText,
      sites,
      status: 7,
      tag: null,
      writer: null,
    },
    fetchPolicy: 'no-cache',
  });

  const handleCreateTranslation = async () => {
    mutation({
      variables: {
        originalTitleId,
        titleIds: Array.from(selectedItems.keys()),
      },
    });
  };

  useEffect(() => {
    if (queryTitles.data) {
      const {
        data: { titlesAsContentManager },
      } = queryTitles;
      const { titles } = titlesAsContentManager;
      const titlesMapped = titles.map((title: ITitle) => ({
        id: title.id,
        title: title.title,
      }));

      setTitles(titlesMapped);
    }
  }, [queryTitles]);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        fullWidth
        onClick={handleOpenModal}
      >
        Replicator by title
      </Button>

      {isOpen && (
        <Modal
          open={isOpen}
          onClose={handleCloseModal}
          aria-labelledby="create-content-translation-modal"
          aria-describedby="create-content-translation-modal-description"
          closeAfterTransition
          className={classes.modal}
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
            className: classes.backdrop,
          }}
        >
          <Fade in={isOpen}>
            <Box className={classes.modalPaper}>
              <Box className={classes.modalHeader}>
                <Box
                  className={clsx(
                    classes.modalHeaderSides,
                    classes.modalHeaderClose,
                  )}
                >
                  <IconButton onClick={handleCloseModal}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="div"
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                  }}
                >
                  <InputLabel
                    className={classes.inputLabel}
                    style={{ marginTop: 0 }}
                  >
                    Titles to replicate the content
                  </InputLabel>
                  <ul style={{ listStyleType: 'none', padding: 0 }}>
                    {Array.from(selectedItems.values()).map((item) => (
                      <li style={{ padding: '5px 0 0' }} key={item.id}>
                        <Link
                          href={`/#/titlesContent?title=${item.id}`}
                          target="_blank"
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Box>

                <Autocomplete
                  id="titles-autocomplete"
                  options={titles}
                  getOptionLabel={(option: any) => (option ? option.title : '')}
                  onChange={handleChange}
                  // value={selectedSite}
                  renderInput={(params) => (
                    <TextField
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      variant="standard"
                      label="SELECT ORIGIN TITLE"
                    />
                  )}
                  onInputChange={(_, newInputValue) => {
                    setFilterSearchText(newInputValue);
                  }}
                />

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{
                    marginTop: '16px',
                  }}
                  onClick={() => handleCreateTranslation()}
                  disabled={!originalTitleId}
                >
                  Create translation
                </Button>
              </div>
            </Box>
          </Fade>
        </Modal>
      )}
    </>
  );
};

export default CreateContentTranslation;
